export default __webpack_public_path__ + "static/media/Aura-Egg__38.b3a82e2f.png";